<template>
  <div>
    <PrimaryBox :flag="true">
      <template slot="title">
        <span>点位信息统计</span>
      </template>
      <div class="content">
        <div class="echartsBox">
          <!--          <div class="select_county">-->
          <!--            <Select v-model="county" @on-change="getEventData">-->
          <!--              <Option v-for="(item,index) in countyList" :key="index" :value="item.indexCode">{{ item.name }}</Option>-->
          <!--            </Select>-->
          <!--          </div>-->
          <Icon type="ios-loading" v-if="eventLoading" size="40" style="margin-top: 20%" class="xvanzhuan"/>
          <div v-if="!eventLoading" id="event"></div>
        </div>
      </div>
    </PrimaryBox>
  </div>
</template>
<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox.vue";
import * as echarts from "echarts";

export default {
  components: {
    PrimaryBox
  },
  props: {
    indexCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      eventLoading: false,
      county: '',
      countyList: [],
      event: [],
      MileageRatios: [],
      eventOptions: {
        title: {
          text: ''
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false,
        },
        dataZoom: [
          {
            show: true,
            type: 'inside',
            yAxisIndex: 0,
            startValue: 0,
            endValue: 15,
            zoomOnMouseWheel:false,  //滚轮是否触发缩放
            moveOnMouseMove:true,  //鼠标滚轮触发滚动
            moveOnMouseWheel:true
          },
        ],
        grid: {
          left: '1%',
          right: '5%',
          bottom: '1%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [],
          nameTextStyle: {
            width: 10
          }
        },
        yAxis: {
          inverse: true,
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            show: true,
            textStyle: {
              color: '#c3dbff',  //更改坐标轴文字颜色
              fontSize : 12      //更改坐标轴文字大小
            }
          },
        },
        series: []
      },
      eventDom: null,
    }
  },
  mounted() {
    console.log('indexCode', this.indexCode)
    // this.getCounty()
    this.county = this.indexCode
    this.getEventData()
  },
  watch: {
    indexCode(val) {
      this.county = val
      this.getEventData()
    }
  },
  methods: {
    // 获取区县
    getCounty() {
      this.eventLoading = true
      this.$http.get(`/api/getLowerLevelDepts`).then(res => {
        if (res.status === 200) {
          this.countyList = res.data
          this.county = this.countyList[0].indexCode
          this.getEventData()
        }
      })
    },
    // 获取事件统计数据
    getEventData() {
      this.eventLoading = true
      this.eventOptions.yAxis.data = []
      this.eventOptions.series = []
      this.$http.get(`/api/getEventNumber?indexCode=${this.county}`).then(res => {
        if (res.status === 200) {
          this.eventLoading = false
          this.event = res.data
          let datas = []
          for (let i in this.event) {
            this.eventOptions.yAxis.data.push(this.event[i].cameraName.toString().length > 10 ? this.event[i].cameraName.substring(0, 10) + '...' : this.event[i].cameraName)
            datas.push(parseInt(this.event[i].eventNumber))
          }
          this.eventOptions.series[0] = {
            name: '事件',
            type: 'bar',
            data: datas,
            color: '#0ee8a7',
            label: {
              show: true,
              position: 'right',
              color: '#007bf4'
            },
            barWidth: 18,
          }
          this.$nextTick(() => {
            this.drawEventChart()
          })
        }
      })
    },
    // 绘制里程比图表
    drawEventChart() {
      this.$nextTick(() => {
        document.getElementById("event").style.display = "block";
        document.getElementById("event").style.width = "100%";
        this.eventDom = echarts.init(document.getElementById("event"));
        this.eventDom.setOption(this.eventOptions);
      })
    },
  }
}
</script>
<style scoped lang="less">
@import "event.less";

#mileage {
  width: 100%;
  height: 100%;
}

#event {
  width: 100%;
  height: 100%;
}

@keyframes xvanzhuan {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg)
  }
}

.xvanzhuan {
  animation: xvanzhuan 1s linear infinite;
}
</style>
